import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// import { formatDateTime } from '../../utils/dateHelpers';

const StockTable = ({ groupedProducts, reservedStock, getStockStatus, filters }) => {
    return (
        <>
            {Object.values(groupedProducts).map(group => (
                <Card key={group._id} className="mb-4">
                    <Card.Header>
                        <h5 className="mb-0">{group.groupName}</h5>
                    </Card.Header>
                    <Card.Body>
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Available Stock</th>
                                        <th>Reserved Qty</th>
                                        <th>Qty After Reserved</th>
                                        <th>Buffer Stock</th>
                                        <th>Status</th>
                                        {/* <th>Last Updated</th> */}
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {group.products
                                        .filter(product => {
                                            // Apply filters here
                                            if (filters?.search) {
                                                const searchTerm = filters.search.toLowerCase();
                                                if (!product.product?.productName?.toLowerCase().includes(searchTerm) &&
                                                    !product.product?.sku?.toLowerCase().includes(searchTerm)) {
                                                    return false;
                                                }
                                            }

                                            if (filters?.stockLevel !== "all") {
                                                const currentStock = product.totalAvailableStock;
                                                switch (filters.stockLevel) {
                                                    case "low":
                                                        return currentStock > 0 && currentStock <= 100;
                                                    case "out":
                                                        return currentStock === 0;
                                                    case "normal":
                                                        return currentStock > 100;
                                                    default:
                                                        return true;
                                                }
                                            }

                                            if (filters?.category) {
                                                return product.product?.category?.toLowerCase().includes(filters.category.toLowerCase());
                                            }

                                            return true;
                                        })
                                        .map(product => {
                                        const productId = product.product._id;
                                        const reserved = reservedStock[productId] || 0;
                                        const afterReserved = product.totalAvailableStock - reserved;
                                        const status = getStockStatus(
                                            afterReserved,
                                            product.product.bufferStock
                                        );
                                        
                                        return (
                                            <tr key={product.product._id}>
                                                <td>
                                                    <div className="fw-bold">{product.product.productName}</div>
                                                    <small className="text-muted">SKU: {product.product.sku}</small>
                                                </td>
                                                <td>
                                                    <div className="fw-bold">{product.totalAvailableStock} {product.product.unitId?.unitCode}</div>
                                                    <div className="mt-1">
                                                        {product.packedStock?.length > 0 && (
                                                            <div className="text-success fs-10" title="Packed Stock">
                                                                <i className="fas fa-box me-1"></i>
                                                                {product.packedStock.reduce((sum, s) => sum + s.availableStock, 0)} {product.product.unitId?.unitCode}
                                                            </div>
                                                        )}
                                                        {product.unpackedStock?.length > 0 && (
                                                            <div className="text-primary fs-10" title="Unpacked/Loose Stock">
                                                                <i className="fas fa-box-open me-1"></i>
                                                                {product.unpackedStock.reduce((sum, s) => sum + s.availableStock, 0)} {product.product.unitId?.unitCode}
                                                            </div>
                                                        )}
                                                        {product.inPackingStock?.length > 0 && (
                                                            <div className="text-warning fs-10" title="Stock currently in Packing Operations">
                                                                <i className="fas fa-spinner fa-spin me-1"></i>
                                                                {product.inPackingStock.reduce((sum, s) => sum + s.availableStock, 0)} {product.product.unitId?.unitCode}
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className={reserved > 0 ? 'text-warning fw-bold' : ''}>
                                                        {reserved} {product.product.unitId?.unitCode}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={afterReserved <= 0 ? 'text-danger fw-bold' : ''}>
                                                        {afterReserved} {product.product.unitId?.unitCode}
                                                    </span>
                                                </td>
                                                <td>{product.product.bufferStock || 0} {product.product.unitId?.unitCode}</td>
                                                <td>
                                                    <Badge bg={status.color}>{status.label}</Badge>
                                                </td>
                                                {/* <td>{formatDateTime(product.stockByLocation[0]?.lastUpdated)}</td> */}
                                                <td>
                                                    <Link 
                                                        to={`/inventory/${productId}`}
                                                        className="btn btn-sm btn-outline-primary"
                                                    >
                                                        Details
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </Card.Body>
                </Card>
            ))}
        </>
    );
};

export default StockTable;
